import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { Action, bindActionCreators, Dispatch } from 'redux';

import * as userActions from 'common.components/user/actions';

import RootThemeView from '../__root-theme-view/sidebar-themes__root-theme-view';

interface OwnProps {
    id: number | string;
    name: string;
    selected?: boolean;
    to: string;
}

type StoreProps = ReturnType<typeof mapDispatchToProps>;

interface Props extends OwnProps, StoreProps {}

export const RootTheme = (props: Props) => {
    const { setWizardVariables } = props;
    const handleParentThemeClick = useCallback(
        (id: string | number) => {
            ym('reachGoal', 'teacher_library_select_root_theme', {
                rootThemeId: id,
            });

            setWizardVariables({ sectionClicked: true });
        },
        [setWizardVariables]
    );

    return <RootThemeView onClick={handleParentThemeClick} {...props} />;
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    const { setWizardVariables } = userActions;

    return bindActionCreators({ setWizardVariables }, dispatch);
};

export default connect(null, mapDispatchToProps)(RootTheme);
